<template>
  <input type="hidden" :name="name+(multiple?'[]':'')" v-for="item in selectedIds" :key="item"
         :value="item">
  <div :class="'ali-select'+(multiple?' multiple':'')+(disabled?' disabled':'')" @click="openModal">
    <div v-if="!selectedIds.length">
      <strong>{{ desc ? desc : 'برای انتخاب کلیک کنید' }}</strong>
    </div>
    <div class="selected-item" v-for="item in selectedTitles" :key="item">
      {{ item }}
    </div>
  </div>
</template>

<script>
import {modalController} from '@ionic/vue';
import Modal from './selectModal'

export default {
  mounted()
  {
    const self = this;
    window.onpopstate = function ()
    {
      if (self.modal)
      {
        self.hardClose = true
        self.modal.dismiss();
      }
    };
  },
  data: () =>
  {
    return {
      hardClose: false,
      selectedIds: [],
      selectedTitles: [],
      modal: null,
    }
  },
  methods: {
    setSelected: function (event)
    {
      const wasSelected = event.target.classList.contains('active');
      event.target.classList.toggle('active');
      const id = event.target.getAttribute('data-value');
      console.log(id)
      if (wasSelected)
      {
        const index = this.selectedIds.indexOf(id);
        if (index !== -1)
        {
          this.selectedIds.splice(index, 1);
          this.selectedTitles.splice(index, 1);
        }
      }
      else
      {
        for (let i = 0; i < this.items.length; i++)
        {
          if (this.items[i][this.itemId] === id)
          {
            if (this.multiple)
            {
              this.selectedIds.push(this.items[i][this.itemId]);
              this.selectedTitles.push(this.items[i][this.itemTitle]);
            }
            else
            {
              this.selectedIds = [this.items[i][this.itemId]];
              this.selectedTitles = [this.items[i][this.itemTitle]];
              if (this.modal)
              {
                this.modal.dismiss()
              }
            }
            break;
          }
        }
      }

      if (typeof this.onChange==='function')
      {
        let selectedItems = [];
        for (let i=0;i<this.selectedIds.length;i++)
        {
          const t = {};
          t[this.itemId] = this.selectedIds[i];
          t[this.itemTitle] = this.selectedTitles[i];
          selectedItems.push(t)
        }
        console.log('calling ')
        console.log(selectedItems)
        this.onChange(selectedItems,this.index)
      }
    },
    async openModal()
    {
      if (this.disabled)
        return
      this.modal = await modalController
          .create({
            component: Modal,
            componentProps: {
              items: this.items,
              itemTitle: this.itemTitle,
              itemId: this.itemId,
              title: this.title,
              setSelected: this.setSelected,
              selectedIds: this.selectedIds,
              search: this.search,
              closeModal: this.closeModal
            },
          })
      await this.$router.push({path: '#modalOpen'})

      const state = {'page_id': 1, 'user_id': 5}
      const title = ''
      const url = this.$route.fullPath + '#modalOppened'
      history.pushState(state, title, url);

      const self = this;
      this.modal.onDidDismiss().then(function ()
      {
        console.log(self.hardClose)
        if (self.hardClose)
        {
          self.hardClose = false;
        }
        else
        {
          window.history.back();
          setTimeout(function (){
            self.hardClose = false;
          },400)
        }
      })
      this.modal.present();
    },
    closeModal()
    {
      if (this.modal)
      {
        this.modal.dismiss()
      }
    }
  },
  watch: {
    items: function ()
    {
      this.selectedIds = [];
      this.selectedTitles = [];
      for (let i = 0; i < this.items.length; i++)
      {
        if (this.items[i].selected)
        {
          this.selectedIds.push(this.items[i][this.itemId]);
          this.selectedTitles.push(this.items[i][this.itemTitle]);
        }
      }
    },
    selectedIds: function ()
    {
      console.log('watch selectedIds')
    }
  },
  props: [
    'items',
      'disabled',
    'itemTitle',
    'itemId',
    'title',
    'multiple',
    'name',
    'search',
    'onChange',
    'desc',
    'index'
  ]
}
</script>

<style scoped>
.ali-select {
  background: #f0f4fb;
  border-radius: 8px !important;
  padding: 5px;
  width: 100%;
  border: 1px solid gainsboro;
}

.ali-select.multiple .selected-item {
  border-radius: 3px !important;
  padding: 4px 10px;
  border: 1px solid gainsboro;
  display: inline-block;
  margin-left: 4px;
}
.ali-select.disabled
{
  background: rgba(255, 255, 255, 0.37);
  color: gray;
  cursor: not-allowed;
}
</style>